export default "__VITE_ASSET__BNjgcWQw__"